module.exports = __webpack_public_path__ + "static/media/footer-image.ac12fd65.jpg";